<template>
  <div class="header-wrapper">
    <div class="logo">
      <img src="../../assets/images/logo.png"/>
    </div>
    <ul class="nav">
      <template v-for="(item, index) in navData">
        <li
            :key="index"
            class="nava">
          <el-dropdown v-if="item.path === '/product'" @command="handleCommand">
            <a :class="{active: navActive === item.path}">
              {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="pay">智慧医疗统一支付云平台</el-dropdown-item>
              <el-dropdown-item command="dz">智慧医疗统一对账云平台</el-dropdown-item>
              <el-dropdown-item command="hqms">分诊排队叫号系统</el-dropdown-item>
              <el-dropdown-item command="3">智慧场所云管理平台</el-dropdown-item>
              <el-dropdown-item command="4">智慧村社管理平台</el-dropdown-item>
              <el-dropdown-item command="5">智慧医疗自助服务系统</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <a @click="handleRoute(item.path)" v-else :class="{active: navActive === item.path}">{{item.name}}</a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'header',
  data () {
    return {
      navActive: '',
      navData: [
        {name: '首页', path: '/home'},
        {name: '产品与服务', path: '/product'},
        // {name: '成功案例', path: '/case'},
        {name: '关于我们', path: '/about'},
        {name: '联系我们', path: '/contact'}
      ]
    }
  },
  mounted () {
    this.navActive = this.$route.path
  },
  methods: {
    handleCommand (com) {
      if (com === 'pay') {
        this.handleRoute('/product', {type: com})
      }
      if (com === 'dz') {
        this.handleRoute('/product1', {type: com})
      }
      if (com === 'hqms') {
        this.handleRoute('/product2', {type: com})
      }
      if (com === '3') {
        this.handleRoute('/product3', {type: com})
      }
      if (com === '4') {
        this.handleRoute('/product4', {type: com})
      }
      if (com === '5') {
        this.handleRoute('/product5', {type: com})
      }
    },
    handleRoute (path, params = {}) {
      this.$router.push({
        path,
        params
      })
    }
  },
  watch: {
    $route (to, from) {
      this.navActive = to.path
      // eslint-disable-next-line no-undef
      app.scrollIntoView()
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .header-wrapper {
    max-width: @width-max;
    margin: 0 auto;
    position: relative;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      display: flex;
      align-items: center;
      img {
        height: 60px;
      }
    }
    .nav {
      display: inline-block;
      vertical-align: top;
      font-weight: 400;
      float: right;
      .nava {
        display: inline;
        position: relative;
        list-style: none;
        cursor: pointer;
        a {
          display: inline-block;
          padding: 0 25px;
          outline: none;
          &.active {
            color: #2dbdf5;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue